// extracted by mini-css-extract-plugin
module.exports =  {"container":"_9cadcb71c3--container--m2zfq","icon":"_9cadcb71c3--icon--US8sm","title":"_9cadcb71c3--title--oC8C4"};